import { Link, type LinkComponentProps } from '@tanstack/react-router'
import type { VariantProps } from 'class-variance-authority'

import { buttonRecipe, cn, Tooltip } from '@/components/base'

type LinkButtonProps = LinkComponentProps<'a'> &
  VariantProps<typeof buttonRecipe> & {
    /**
     * Names the link on hover, and to assistive tech — the same one string,
     * for the same reason `Button` has it.
     */
    tooltip?: string
  }

/**
 * A link that looks like a button.
 *
 * Nesting a `<button>` inside an `<a>` is invalid and gives the keyboard two
 * stops for one target, so a control that navigates is an anchor wearing the
 * button recipe rather than the two elements combined.
 */
export function LinkButton({
  variant,
  size,
  className,
  tooltip,
  ...rest
}: LinkButtonProps) {
  const link = (
    <Link
      aria-label={tooltip}
      className={cn(buttonRecipe({ variant, size }), className)}
      {...rest}
    />
  )

  return (
    <Tooltip label={tooltip} side="top">
      {link}
    </Tooltip>
  )
}
